import React from 'react';
export function StatementSlide() {
  return <section className="slide" style={{
    backgroundColor: '#0d1520'
  }} data-id="element-333">
      <div className="flex flex-row w-full h-full min-h-0" data-id="element-334">
        {/* Left Panel — 40% text on pure black */}
        <div className="flex flex-col justify-center w-[40%] flex-shrink-0 min-h-0 overflow-hidden relative bg-[#0D1520]" style={{
        borderLeft: '3px solid #4A90D9',
        padding: 'var(--slide-padding)'
      }} data-id="element-335">
          {/* Blue italic label */}
          <p className="italic font-semibold mb-[clamp(0.5rem,1.5vw,1rem)] animate-fade-slide relative z-10" style={{
          color: '#4A90D9',
          fontSize: 'var(--body-size)',
          animationDelay: '0.1s'
        }} data-id="element-336">
            The Insight.
          </p>

          {/* Bold heading */}
          <h1 className="font-black tracking-tight text-white leading-[1.1] animate-fade-slide relative z-10" style={{
          fontSize: 'var(--title-size)',
          animationDelay: '0.2s'
        }} data-id="element-337">
            <span className="block text-white/50" style={{
            marginBottom: 'clamp(-0.15rem, -0.3vw, -0.3rem)'
          }} data-id="element-338">
              Maps optimize for speed.
            </span>
            <span className="block text-white" style={{
            fontSize: 'calc(var(--title-size) * 1.15)'
          }} data-id="element-339">
              Humans optimize for{' '}
              <span style={{
              color: '#4A90D9'
            }} data-id="element-340">
                experience.
              </span>
            </span>
          </h1>

          {/* Blue accent underline */}
          <div className="mt-[clamp(1rem,2.5vw,2rem)] mb-[clamp(1rem,2.5vw,2rem)] animate-fade-slide relative z-10" style={{
          width: 'clamp(40px, 5vw, 60px)',
          height: '3px',
          backgroundColor: '#4A90D9',
          animationDelay: '0.3s'
        }} data-id="element-341" />

          {/* Body paragraph */}
          <p className="text-white/45 leading-relaxed animate-fade-slide relative z-10" style={{
          fontSize: 'var(--body-size)',
          maxWidth: '95%',
          animationDelay: '0.4s'
        }} data-id="element-342">
            Maps were built for cars, not people. Their core systems optimize
            roads, traffic, and speed — then awkwardly adapt that same logic to
            walking.
          </p>
        </div>

        {/* Right Panel — 60% full-bleed photo */}
        <div className="flex-1 relative overflow-hidden" data-id="element-343">
          <img src="https://cdn.magicpatterns.com/uploads/sBrZQkrsTkGAehJU1JXDRx/street-lined-with-colorful-buildings-decorated-with-colorful-umbrellas-hanging.jpg" alt="Colorful street with hanging umbrellas — optimized for experience" className="absolute inset-0 w-full h-full object-cover animate-fade-slide" style={{
          filter: 'brightness(1.1) saturate(1.3) contrast(1.05)',
          animationDelay: '0.4s'
        }} data-id="element-344" />

          {/* Gradient for card readability */}
          <div className="absolute inset-0" style={{
          background: 'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.2) 50%, transparent 100%)'
        }} data-id="element-345" />

          {/* Frosted glass route timeline card */}
          <div className="absolute top-[clamp(0.75rem,2vw,1.5rem)] left-[clamp(0.75rem,2vw,1.5rem)] right-[clamp(0.75rem,2vw,1.5rem)] animate-fade-slide rounded-xl overflow-hidden" style={{
          animationDelay: '0.5s',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          backdropFilter: 'blur(24px)',
          WebkitBackdropFilter: 'blur(24px)',
          border: '1px solid rgba(255,255,255,0.12)',
          padding: 'clamp(0.8rem, 2vw, 1.4rem) clamp(1rem, 2.2vw, 1.6rem)'
        }} data-id="element-346">
            {/* Card header */}
            <div className="flex items-center justify-between" style={{
            marginBottom: 'clamp(0.5rem, 1.2vw, 1rem)'
          }} data-id="element-347">
              <div className="flex items-center" style={{
              gap: 'clamp(0.3rem, 0.6vw, 0.5rem)'
            }} data-id="element-348">
                <span style={{
                fontSize: 'clamp(0.9rem, 1.4vw, 1.1rem)'
              }} data-id="element-349">
                  🚶
                </span>
                <span className="font-bold text-white" style={{
                fontSize: 'clamp(0.75rem, 1.3vw, 1rem)'
              }} data-id="element-350">
                  Scenic route
                </span>
              </div>
              <span className="text-white/50" style={{
              fontSize: 'clamp(0.6rem, 1vw, 0.8rem)'
            }} data-id="element-351">
                18 min · 0.5 mi
              </span>
            </div>

            {/* Timeline */}
            <div className="flex flex-col" style={{
            gap: 'clamp(0.15rem, 0.5vw, 0.35rem)'
          }} data-id="element-352">
              {/* Stop 1 — Start */}
              <div className="flex" style={{
              gap: 'clamp(0.4rem, 0.8vw, 0.6rem)'
            }} data-id="element-353">
                {/* Timeline column */}
                <div className="flex flex-col items-center flex-shrink-0" style={{
                width: 'clamp(14px, 1.5vw, 20px)'
              }} data-id="element-354">
                  <div className="rounded-full flex-shrink-0" style={{
                  width: 'clamp(8px, 0.9vw, 12px)',
                  height: 'clamp(8px, 0.9vw, 12px)',
                  backgroundColor: '#4A90D9'
                }} data-id="element-355" />
                  <div className="flex-1" style={{
                  width: '2px',
                  backgroundColor: 'rgba(255,255,255,0.15)',
                  minHeight: 'clamp(20px, 3vh, 34px)'
                }} data-id="element-356" />
                </div>
                {/* Content */}
                <div style={{
                paddingBottom: 'clamp(0.25rem, 0.6vw, 0.45rem)'
              }} data-id="element-357">
                  <div className="flex items-center" style={{
                  gap: 'clamp(0.4rem, 0.7vw, 0.6rem)'
                }} data-id="element-358">
                    <span className="font-semibold text-white" style={{
                    fontSize: 'clamp(0.65rem, 1.1vw, 0.9rem)'
                  }} data-id="element-359">
                      Market Street
                    </span>
                    <span className="text-white/40" style={{
                    fontSize: 'clamp(0.55rem, 0.9vw, 0.7rem)'
                  }} data-id="element-360">
                      Start here
                    </span>
                  </div>
                </div>
              </div>

              {/* Stop 2 — Umbrella Alley */}
              <div className="flex" style={{
              gap: 'clamp(0.4rem, 0.8vw, 0.6rem)'
            }} data-id="element-361">
                <div className="flex flex-col items-center flex-shrink-0" style={{
                width: 'clamp(14px, 1.5vw, 20px)'
              }} data-id="element-362">
                  <div className="rounded-full flex-shrink-0" style={{
                  width: 'clamp(8px, 0.9vw, 12px)',
                  height: 'clamp(8px, 0.9vw, 12px)',
                  backgroundColor: '#4A90D9',
                  opacity: 0.7
                }} data-id="element-363" />
                  <div className="flex-1" style={{
                  width: '2px',
                  backgroundColor: 'rgba(255,255,255,0.15)',
                  minHeight: 'clamp(20px, 3vh, 34px)'
                }} data-id="element-364" />
                </div>
                <div style={{
                paddingBottom: 'clamp(0.25rem, 0.6vw, 0.45rem)'
              }} data-id="element-365">
                  <div className="flex items-center justify-between" style={{
                  gap: 'clamp(0.4rem, 0.7vw, 0.6rem)'
                }} data-id="element-366">
                    <span className="font-semibold text-white" style={{
                    fontSize: 'clamp(0.65rem, 1.1vw, 0.9rem)'
                  }} data-id="element-367">
                      Umbrella Alley
                    </span>
                    <span className="text-white/35" style={{
                    fontSize: 'clamp(0.55rem, 0.85vw, 0.65rem)'
                  }} data-id="element-368">
                      8 min
                    </span>
                  </div>
                  <span className="text-white/40" style={{
                  fontSize: 'clamp(0.55rem, 0.9vw, 0.7rem)'
                }} data-id="element-369">
                    Colorful canopy walkway
                  </span>
                  <div className="flex flex-wrap" style={{
                  gap: 'clamp(0.25rem, 0.5vw, 0.4rem)',
                  marginTop: 'clamp(0.2rem, 0.4vw, 0.35rem)'
                }} data-id="element-370">
                    <span className="rounded-full text-white/70" style={{
                    fontSize: 'clamp(0.5rem, 0.85vw, 0.65rem)',
                    padding: 'clamp(2px, 0.3vw, 4px) clamp(6px, 0.8vw, 10px)',
                    backgroundColor: 'rgba(255,255,255,0.1)',
                    border: '1px solid rgba(255,255,255,0.12)'
                  }} data-id="element-371">
                      🎨 Artistic
                    </span>
                    <span className="rounded-full text-white/70" style={{
                    fontSize: 'clamp(0.5rem, 0.85vw, 0.65rem)',
                    padding: 'clamp(2px, 0.3vw, 4px) clamp(6px, 0.8vw, 10px)',
                    backgroundColor: 'rgba(255,255,255,0.1)',
                    border: '1px solid rgba(255,255,255,0.12)'
                  }} data-id="element-372">
                      ☂️ Vibrant
                    </span>
                  </div>
                </div>
              </div>

              {/* Stop 3 — Destination */}
              <div className="flex" style={{
              gap: 'clamp(0.4rem, 0.8vw, 0.6rem)'
            }} data-id="element-373">
                <div className="flex flex-col items-center flex-shrink-0" style={{
                width: 'clamp(14px, 1.5vw, 20px)'
              }} data-id="element-374">
                  <div className="rounded-full flex-shrink-0" style={{
                  width: 'clamp(10px, 1.1vw, 14px)',
                  height: 'clamp(10px, 1.1vw, 14px)',
                  backgroundColor: '#4A90D9'
                }} data-id="element-375" />
                </div>
                <div data-id="element-376">
                  <div className="flex items-center" style={{
                  gap: 'clamp(0.4rem, 0.7vw, 0.6rem)'
                }} data-id="element-377">
                    <span className="font-semibold text-white" style={{
                    fontSize: 'clamp(0.65rem, 1.1vw, 0.9rem)'
                  }} data-id="element-378">
                      Sam's Coffee ☕
                    </span>
                    <span className="text-white/35" style={{
                    fontSize: 'clamp(0.55rem, 0.85vw, 0.65rem)'
                  }} data-id="element-379">
                      18 min
                    </span>
                  </div>
                  <span className="text-white/40" style={{
                  fontSize: 'clamp(0.55rem, 0.9vw, 0.7rem)'
                }} data-id="element-380">
                    Your destination
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}